import { Component, Input } from "@angular/core";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";
import { getTotalDiscount } from "@edp-store/selectors/contract.selectors";

@Component({
    selector: "edp-header-savings",
    templateUrl: "./edp-header-savings.component.html",
    styleUrls: ["./edp-header-savings.component.scss"]
})
export class EdpHeaderSavingsComponent {
    @Input() set contractId(contractId: string) {
        this.link = `/energia/${contractId}/leisure`;
    }

    public totalDiscount$ = this.store.pipe(select(getTotalDiscount));
    public link: string;

    constructor(
        private store: Store<IAppState>
    ) { }

}
